module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Italic_1_42fe60f3.f858271d.woff2";